// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2ZgIV","resendInfoText":"OnGoingPaymentBox_resendInfoText__1ovV9"};